import * as React from 'react';
import { IconVector } from 'client/ui/icon/IconVector';
import { ProcedureRecipient } from 'common/schema/Procedure';
import { assertNever } from 'server/utils/typings/assertNever';

export interface ProcedureRecipientIconProps {
  recipient: ProcedureRecipient;
}

export function ProcedureRecipientIcon(props: ProcedureRecipientIconProps) {
  switch (props.recipient) {
    case ProcedureRecipient.Citizen:
      return <IconVector icon="Citizen" />;
    case ProcedureRecipient.Employee:
      return <IconVector icon="Employee" />;
    case ProcedureRecipient.Company:
      return <IconVector icon="Company" />;
    default:
      assertNever(props.recipient);
  }
}
